var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 10A6.674 6.674 0 0110 16.666 6.674 6.674 0 013.333 10c0-2.1.978-3.973 2.5-5.196v-2.01C3.346 4.237 1.666 6.924 1.666 10c0 4.595 3.739 8.333 8.334 8.333s8.333-3.738 8.333-8.333c0-4.595-3.738-8.333-8.333-8.333v1.666A6.674 6.674 0 0116.666 10z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.667 1.667H7.5V7.5L1.667 1.667z",
    fill: "#fff"
  })));
}
export default SvgRestart;